<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 18"
        width="16"
        height="16"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="p-0 mr-1"
    >
        <path
            d="M9 15.75V15.75C5.27175 15.75 2.25 12.7283 2.25 9V9C2.25 5.27175 5.27175 2.25 9 2.25V2.25C12.7283 2.25 15.75 5.27175 15.75 9V9C15.75 12.7283 12.7283 15.75 9 15.75Z"
            class="fill-none stroke-ihh-dark-salmon hover:stroke-ihh-dark-salmon"
        />
        <path d="M9 12.75V9H8.25" class="fill-none stroke-ihh-dark-salmon hover:stroke-ihh-dark-salmon" />
        <path
            d="M8.81175 6C8.70825 6 8.62425 6.084 8.625 6.1875C8.625 6.291 8.709 6.375 8.8125 6.375C8.916 6.375 9 6.291 9 6.1875C9 6.084 8.916 6 8.81175 6"
            class="sfill-none stroke-ihh-dark-salmon hover:stroke-ihh-dark-salmon"
        />
    </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
